import React from 'react';

const Footer = () => {
  return (
    <footer 
      className="w-full py-6 px-6 text-center bg-background mb-16"
      data-testid="global-footer"
    >
      <p className="text-xs text-muted-foreground">
        © JudeBelaDesign, LLC. All Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;
